module.exports = __webpack_public_path__ + "static/media/sa.ffc9394f.png";